enum ITypePricingProject {
  HoursSeniority = "HOURS_SENIORITY",
  HoursFactory = "HOURS_FACTORY",
}

export default ITypePricingProject;
